import BulkCreateAlarms from '@/pages/Alarms/BulkCreate';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.BulkCreateAlarms = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        this.reactRoot = createRoot(document.getElementById(this.id));
        this.reactRoot.render(<BulkCreateAlarms/>);
    },

    onClose: function() {
        if (this.reactRoot) {
            this.reactRoot.unmount(); // Unmount the React component
            this.reactRoot = null; // Clean up reference
        }
    }
});
